
export default {
    InvalidURL: `The link you've followed is invalid`,
    VerificationFailed: `Verification process failed`,
    UnableToDetermineUserRole: `An error occured while determining your Coreo role`,
    OrganisationInvitationAcceptFailed: `Unable to accept organisation invitation`,
    UnableToGetProjectOverview: 'Unable to fetch project - link is invalid or the project does not exist'
}